module.exports = "/images/logo.png?6478bcbf96ade0fbc5c093ac0a6d861b";